<template>
  <section v-if="front.searchResults.length" class="section search-results-section">
    <div class="section-heading">
      <div>
        <p class="section-kicker">搜索结果</p>
        <h2>{{ front.searchKeyword }} 相关内容</h2>
      </div>
      <button type="button" class="text-link" @click="front.clearSearch">关闭</button>
    </div>
    <div class="topic-list">
      <button v-for="item in front.searchResults" :key="`${item.source}-${item.id}`" type="button" @click="front.openSearchResult(item)">
        <strong>{{ item.title }}</strong>
        <span>{{ item.summary || item.type || '公开内容' }}</span>
      </button>
    </div>
  </section>
  <section v-else-if="front.searchSubmittedKeyword" class="section search-results-section">
    <div class="section-heading">
      <div>
        <p class="section-kicker">搜索结果</p>
        <h2>未找到与 {{ front.searchSubmittedKeyword }} 匹配的内容</h2>
      </div>
      <button type="button" class="text-link" @click="front.clearSearch">关闭</button>
    </div>
    <p class="muted-copy">当前搜索范围为已加载的新闻、通知、党建和 CMS 栏目内容；后台发布内容后会自动纳入搜索。</p>
  </section>
</template>

<script>
export default {
  name: 'SearchResultsPanel',
  inject: ['front']
}
</script>
